export default class CookieSettings {
  public id = ''
  public description = ''
  public defaultValue = ''
}
